import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export type DeleteProgramResponse = {
  success: boolean;
  message: string;
  data?: any;
};

const deleteProgram = async (id: string): Promise<DeleteProgramResponse> => {
  const { data } = await customAxios.delete<DeleteProgramResponse>(
    `/programs/program/${id}`
  );
  return data;
};

type DeleteProgramArg = {
  id: string;
};

export const useDeleteProgram = () => {
  const queryClient = useQueryClient();

  return useMutation<DeleteProgramResponse, AxiosError, DeleteProgramArg>({
    mutationFn: ({ id }) => deleteProgram(id),
    onSuccess: async (data) => {
      showNotification({
        title: "Success",
        message: data.message,
        color: "green",
      });

      await queryClient.invalidateQueries(["programs"]);
    },
    onError: (error) =>
      showNotification({
        title: "Error",
        message:
          (error.response?.data as { message?: string })?.message ??
          "Failed to delete program",
        color: "red",
      }),
  });
};
